<template>
  <div class="introduce">
    <div class="introduceTop">
      <div v-for="(item, index) in list" :key="index" class="introduceEvery">
        <img :src="item.url" alt="" />
        <div class="introduceText">
          {{ item.text }}
        </div>
      </div>
    </div>
    <div class="introduceMain">
      <div v-for="(item, index) in pointList" :key="index" class="Every">
        <img :src="item.url" alt="" class="everyUrl" />
        <div class="introduceText">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
          <div class="times between">
            <div class="between">
              <img src="@/assets/shizhong.png" alt="" class="shizhong" />
              <div>{{ item.times }}</div>
            </div>
            <!-- <div>阅读全文<i class="el-icon-arrow-right"></i></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [
        {
          url: require("@/assets/Slice82.png"),
          text: "德清县县委组织部等深入民匠有约平台调研“三支队伍”建设情况",
        },
        {
          url: require("@/assets/Slice83.png"),
          text: "浙江省应急管理宣传教育中心主任薛芳跃一行莅临民匠有约平台 共谋“流动…",
        },
        {
          url: require("@/assets/Slice84.png"),
          text: "民匠有约：育名匠，促安全，共绘经济新篇章",
        },
      ],
      pointList: [
        {
          url: require("@/assets/Slice86.png"),
          title:
            "浙江省应急管理宣传教育中心主任薛芳跃一行莅临民匠有约平台 共谋“流动焊”安全监管新策略",
          text: " 为深入了解“流动焊”等特种作业的安全监管现状，搭建企业与特种作业人员之间的供需桥梁，推动安全生产培训机构基本条件的全面落实与“两个专项治理”工作的深入开展。8月16日，浙江省应急管理宣传教育中心主任薛芳跃、考试管理科科长莫水祥、杭州市应急宣教和保障中心副主任吴建良一行莅临“民匠有约”平台进行调研和指导。",
          times: "2024-08-20",
        },

        {
          url: require("@/assets/Slice81.png"),
          title: "民匠有约：育名匠，促安全，共绘经济新篇章",
          text: "为解决“流动焊”安全监管难题，搭建企业与特种作业人员供需双方的桥梁，8月14日，浙江省应急管理厅党委委员、副厅长王金永一行来到“民匠有约”平台，就平台的特种作业服务、安全意识教育、符合“首发经济”条件及具体作业流程监管等方面进行了全面细致的调研。",
          times: "2024-08-17",
        },
        {
          url: require("@/assets/Slice87.png"),
          title:
            "民匠有约平台积极响应杭州市应急管理局专项工作指导 共筑安全生产培训新高地",
          text: "为认真贯彻落实习近平总书记关于安全生产重要指示批示精神，7月30日杭州市应急管理局宣保中心副主任吴建良一行莅临民匠有约平台进行专项工作指导。杭州市钱塘区应急管理局副局长胡亚奇陪同参与指导。",
          times: "2024-08-05",
        },
        {
          url: require("@/assets/Slice88.png"),
          title: "省人力社保厅党组书记、厅长吴伟斌 一行莅临民匠有约",
          text: "在实地考察中，吴伟斌一行详细了解了平台在智能化考评技术应用、企业人才数字化供需对接、技能人才职业全生命周期服务与管理等方面的创新成果。",
          times: "2024-07-20",
        },
        {
          url: require("@/assets/Slice89.png"),
          title:
            "领导来访 | 杭州市应急管理局党委书记、局长潘渭一行莅临民匠有约调研指导工作",
          text: " 7月4日下午，杭州市应急管理局党委书记、局长潘渭一行到国通培训中心钱塘基地进行调研。市应急管理局党委委员、副局长李雄飞，基础处处长吕杨钦，宣保中心主任翁如彬，办公室吴俊参与调研。",
          times: "2024-07-05",
        },
        {
          url: require("@/assets/Slice80.png"),
          title: "领导来访|浙江省委办公厅一行调研“民匠有约”平台",
          text: "6月26日，浙江省委办公厅一行莅临“民匠有约”平台，对“三支队伍”建设及技能人才增收模式进行了深入的调研。杭州钱塘新区党工委副书记、钱塘区委副书记、政法委书记钟建利，钱塘区人社局党组成员、副局长颜燕炯等领导陪同参加。",
          times: "2024-06-28",
        },
        {
          url: require("@/assets/Slice9.png"),
          title: "领导来访|杭州市委常委、秘书长朱华调研我单位",
          text: "5月28日，杭州市委常委、秘书长、改革办主任朱华率队到我单位进行调研，重点关注“三支队伍”改革进展及高质量、高素养、高技能技能人才培养模式改革情况。市委办公厅副主任金伟、市委改革办副主任连俊峰，市人力资源和社会保障局党组书记、局长董悦，钱塘区党工委副书记、钱塘区委副书记、政法委书记钟建利，以及钱塘区委组织部副部长、区委编办主任、区人力资源和社会保障······",
          times: "2024-06-04",
        },

        {
          url: require("@/assets/Rectangle_395.png"),
          title: "领导来访|杭州市人力社保局领导宣向东一行调研“民匠有约”平台",
          text: "2024年5月21日下午，杭州市人力社保局党组成员、二级巡视员宣向东，市职业能力建设指导服务中心主任冯士心，市人力社保局职业能力建设处副处长姜发利，市职业能力建设指导服务中心副科长方英群等一行人莅临我单位，对“民匠有约”供需服务平台进行了深入调研。",
          times: "2024-05-24",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.introduce {
  font-family: PingFang SC, PingFang SC;
  padding: 80px 360px;
  .introduceTop {
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    font-size: 18px;
    color: #141414;
    line-height: 28px;
    text-align: left;
    .introduceEvery {
      width: 365px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.07);
      border-radius: 8px 8px 8px 8px;
      .introduceText {
        padding: 26px 24px;
      }
    }
  }
}
.introduceMain {
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.07);
  border-radius: 8px 8px 8px 8px;
  padding: 44px 44px;
  margin-top: 90px;
  text-align: left;
  font-family: PingFang SC, PingFang SC;
  .Every {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #606266;
    line-height: 22px;
    border-bottom: 1px solid #dcdfe6;
    .introduceText {
      padding: 32px 32px;
    }
    .title {
      font-weight: 500;
      font-size: 18px;
      color: #141414;
    }
    .text {
      font-weight: 400;
      font-size: 14px;
      color: #606266;
      line-height: 34px;
      margin-top: 10px;
    }
    .times {
      justify-content: space-between;
      margin-top: 36px;
    }
  }
}
.between {
  display: flex;
  align-items: center;
  img {
    margin-right: 10px;
  }
}

@media (max-width: 750px) {
  .introduce {
    padding: 80px 120px;
  }
  .introduceEvery {
    img {
      width: 365px;
      height: 200px;
    }
  }
  .everyUrl {
    width: 242px;
    height: 150px;
  }
  .shizhong {
    width: 16px;
    height: 16px;
  }
}
</style>
